<template>
  <div class="home">
    <div slot="header" style="height: 100px" class="clearfix">
      <el-button type="primary" style="margin: 10px 20px 0; float: right" @click="hightFilter">{{ $t('进度展示.高级筛选')
      }}</el-button>
      <el-select style="margin: 10px 20px 0; float: right" filterable v-model="modelId" :title="$t('进度展示.模型选择')"
        :placeholder="$t('进度展示.模型选择')" @change="modelChange">
        <el-option v-for="item in options" :key="item.modelId" :label="item.name" :value="item.modelId"></el-option>
      </el-select>

      <div style="
          float: right;
          display: flex;
          margin: 15px 10px 0;
          align-items: center;
        " v-for="item in color" :key="item.value" @click="changeClick(item)">
        <el-button :style="{ background: item.value, opacity: item.isClick ? 1 : 0.2 }"></el-button>
        <p style="margin-left: 6px">{{ item.name }}</p>
      </div>
    </div>
    <div id="left1">
      <div id="drag" style="top: 9%">
        <div class="Yuan" @click="testShowBtn">
          <span></span>
          <span></span>
        </div>
        <div class="Yuan-title" style="width: 185px; max-height: 730px">
          <div class="YuanTitleDrag"></div>
          <div style="width: 100%; height: 40px">
            <el-button type="primary" size="mini" v-if="zTeeObj" style="width: 100%" @click="ischeckAllMethods">{{
              ischeckAll ? $t('进度展示.取消全选') : $t('进度展示.全选') }}</el-button>
          </div>

          <div class="zTreeDiv">
            <ul id="ProgressShowTree" class="ztree" style="min-height: 200px; margin-left: 20px"></ul>
          </div>
        </div>
      </div>
    </div>
    <div id="ProgressShowRemenu">
      <ul>
        <li id="addProgressShow">{{ $t('进度展示.添加') }}</li>
        <li id="updateProgressShow">{{ $t('进度展示.修改') }}</li>
        <li id="delProgressShow">{{ $t('进度展示.删除') }}</li>
      </ul>
    </div>
    <div id="MyViewerDiv"></div>
    <!-- 批量文件添加节点 -->
    <el-dialog title="修改节点" :visible.sync="updateShow" width="40%" center>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item :label="$t('进度展示.名称')">
          <el-input v-model="selectNode.pgsw07" :placeholder="$t('进度展示.请输入名称')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('进度展示.状态')">
          <el-select v-model="selectNode.pgsw03" :placeholder="$t('进度展示.请选择状态')">
            <el-option v-for="item in color" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t('进度展示.提交') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('进度展示.筛选条件')" :visible.sync="hightFilterShow" width="50%" center="">
      <el-form ref="form" v-loading="searchloading" :element-loading-text="$t('进度展示.初始化模型数据中')"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :model="filterModel"
        label-width="10%">
        <el-form-item :label="$t('进度展示.筛选条件')" style="max-height: 300px; min-height: 150px; overflow: auto">
          <div v-for="(item, index) in filterModel.condition" :key="index"
            :style="{ marginTop: index > 0 ? '5px' : '0px' }">
            <el-select v-if="index > 0" v-model="item.search4" style="width: 100px">
              <el-option :label="$t('进度展示.并且')" value="并且"></el-option>
              <el-option :label="$t('进度展示.或者')" value="或者"></el-option>
            </el-select>

            <el-select v-model="item.search1" style="width: 250px; margin-left: 2px" filterable="">
              <el-option v-for="(item1, index1) in item.searchCon" :label="item1.name" :value="item1.name"
                :key="index1"></el-option>
            </el-select>
            <el-select v-model="item.search2" style="width: 100px; margin-left: 2px">
              <el-option :label="$t('进度展示.大于')" value=">"></el-option>
              <el-option :label="$t('进度展示.小于')" value="<"></el-option>
              <el-option :label="$t('进度展示.等于')" value="="></el-option>
              <el-option :label="$t('进度展示.包含')" value="include"></el-option>
            </el-select>
            <!-- <el-input
              style="width: 150px; margin-left: 2px"
              v-model="item.search3"
              placeholder="请输入条件"
            >
            </el-input> -->
            <el-select v-model="item.search3" style="width: 150px; margin-left: 2px" filterable allow-create>
              <el-option v-for="(item1, index1) in item.searchCon.find(
                (x) => x.name == item.search1
              )
                ? item.searchCon.find((x) => x.name == item.search1).list
                : []" :label="item1" :value="item1" :key="index1"></el-option>
            </el-select>
            <el-button type="success" style="margin-left: 5px" size="mini" icon="el-icon-plus" circle v-if="index == 0"
              @click="dealCon(index, 'add')"></el-button>
            <el-button type="danger" size="mini" style="margin-left: 5px" icon="el-icon-delete" circle v-else
              @click="dealCon(index, 'del')"></el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="SubmitSerch">{{ $t('进度展示.立即查询') }}</el-button>
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              {{ $t('进度展示.筛选范围') }}：<br />{{ $t('进度展示.当前选择构件') }}，<br />
              {{ $t('进度展示.无选择则以全模型') }}
            </div>
            <el-button type="warning" @click="refreshModelData">{{ $t('进度展示.刷新数据') }}</el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetModelListByXid,
  AddOrUpdateProgressShow,
  DropProgressShow,
  DelProgressShow,
  GetProgressShow,
  getProgressShowState
} from "@/setAxios";
import zTree from "@/components/zTree";
import interact from "interactjs";
export default {
  name: "progressShow",
  components: { zTree },
  data() {
    return {
      color: [
        // { name: "未启动", value: "#6b6b6b", isClick: true },
        // { name: "未启动延期", value: "#ffffff", isClick: true },
        // { name: "执行中", value: "#ff0000", isClick: true },
        // { name: "已完成延期", value: "#ff9900", isClick: true },
        // { name: "已完成", value: "#12a9ae", isClick: true },
        // { name: "已完成提前", value: "#9933ff", isClick: true },
        // { name: "执行中延期", value: "#3300ff", isClick: true },
      ],
      modelId: "",
      options: [],
      zTeeObj: null,
      ids: "",
      selectNode: {},
      quanxian: false,
      updateShow: false,
      ischeckAll: false,
      //高级搜索开始---------------------------
      filterModel: {
        condition: [
          {
            search1: null,
            searchCon: [],
            search2: null,
            search3: null,
            search4: "并且",
          },
        ],
      },
      searchloading: false,
      hightFilterShow: false,
      searchCon: {
        search1: null,
        searchCon: [],
        search2: null,
        search3: null,
        search4: "并且",
      },
      modelData: [],
      //高级搜索结束-----------------------------
    };
  },
  methods: {
    ischeckAllMethods() {
      this.zTeeObj.checkAllNodes(!this.ischeckAll);
      this.ischeckAll = !this.ischeckAll;
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        this.ids += _split + element.pgsw01;
        _split = ",";
      });
      this.modelProgress();
    },
    //高级筛选开始---------------------------------------------
    refreshModelData() {
      this.searchloading = true;
      EaBIM.DealModelData();
    },
    dealCon(index, type) {
      if (type == "add") {
        this.filterModel.condition.push(
          JSON.parse(JSON.stringify(this.searchCon))
        );
      } else {
        delete this.filterModel.condition.splice(index, 1);
      }
    },
    SubmitSerch() {
      var a = this.filterModel.condition.filter(
        (y) => y.search1 == null || y.search2 == null || y.search3 == null
      );
      if (a.length) {
        this.$message.error(this.$t('进度展示.请填写完整筛选条件'));
        return;
      }
      var showData = this.modelData.filter((ele) => {
        let bol = true;
        this.filterModel.condition.forEach((ele2) => {
          if (ele2.search4 == "并且") {
            if (ele2.search2 == ">") {
              bol = bol && ele[ele2.search1] > ele2.search3;
            } else if (ele2.search2 == "<") {
              bol = bol && ele[ele2.search1] < ele2.search3;
            } else if (ele2.search2 == "include") {
              bol = bol && ele[ele2.search1].includes(ele2.search3);
            } else {
              bol = bol && ele[ele2.search1] == ele2.search3;
            }
          } else {
            if (ele2.search2 == ">") {
              bol = bol || ele[ele2.search1] > ele2.search3;
            } else if (ele2.search2 == "<") {
              bol = bol || ele[ele2.search1] < ele2.search3;
            } else if (ele2.search2 == "include") {
              bol = bol || ele[ele2.search1].includes(ele2.search3);
            } else {
              bol = bol || ele[ele2.search1] == ele2.search3;
            }
          }
        });
        return bol;
      });
      var dbIds = [];
      showData.forEach((v) => {
        dbIds.push(v["dbId"]);
      });
      if (dbIds.length)
        this.$message.success(`${this.$t('进度展示.一共查找出')}${dbIds.length}${this.$t('进度展示.个构件')}`);
      else this.$message.warning(this.$t('进度展示.暂无符合条件的构件'));
      EaBIM.view.select(dbIds);
    },
    DealModelData(data) {

      this.$message.success(`${this.$t('进度展示.初始化')}${data.length}${this.$t('进度展示.个构件')}`);
      this.modelData = data;
      this.searchloading = false;
      var data1 = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        Object.keys(element).forEach((key) => {
          var item = data1.find((x) => x.name == key);
          if (item) {
            if (!item.list.includes(element[key]))
              data1.find((x) => x.name == key).list.push(element[key]);
          } else {
            data1.push({
              name: key,
              list: [element[key]],
            });
          }
        });
      }
      data1 = data1.filter(
        (x) => x.list.length > 0 && x.list[0] + "".trim() != ""
      );
      data1.forEach((v) => {
        v.list = v.list.splice(0, 100);
      });
      this.searchCon = {
        search1: null,
        searchCon: data1,
        search2: null,
        search3: null,
        search4: "并且",
      };
      this.filterModel.condition = [
        {
          search1: null,
          searchCon: data1,
          search2: null,
          search3: null,
          search4: "并且",
        },
      ];
    },
    //高级筛选
    hightFilter() {
      this.hightFilterShow = true;
      if (!this.modelData.length) {
        this.searchloading = true;
        EaBIM.DealModelData();
      }
    },
    //高级筛选结束---------------------------------------------
    modelProgress(type) {
      var node = this.ids.split(",").map(Number);
      var list = this.selectData.list.filter(
        (x) => node.includes(x.pgsw01) && x.pgsw04 != null
      );
      if (type == "select" && list.length) {
        var dbids = list[0].pgsw04;
        EaBIM.view.select(dbids.split(",").map(Number));
      } else EaBIM.progressShow(list);
    },
    onSubmit() {
      // 已有构件
      // if (!this.selectNode.pgsw04) {
      //   if (!EaBIM.view.getSelection().length) {
      //     this.$message.error("请选择构件！");
      //     return;
      //   }
      //   this.selectNode.pgsw04 = EaBIM.view.getSelection().join(",");
      // }
      if (EaBIM.view.getSelection().length) {
        this.selectNode.pgsw04 = EaBIM.view.getSelection().join(",");
      }
      if (
        this.selectNode.pgsw07 == null ||
        this.selectNode.pgsw07.trim() == ""
      ) {
        this.$message.error(this.$t('进度展示.请填写节点名称'));
        return;
      }
      // if (
      //   this.selectNode.pgsw03 == null ||
      //   this.selectNode.pgsw03.trim() == ""
      // ) {
      //   this.$message.error("请选择节点状态！");
      //   return;
      // }

      let params = this.selectNode;
      AddOrUpdateProgressShow(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: this.$t('进度展示.成功'),
          });
          params = {
            modelId: this.modelId,
          };
          GetProgressShow({ params }).then((res) => {
            this.selectData.list = res.Data ? res.Data : [];
            this.init();
          });
          this.updateShow = false;
        }
      });
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },
    changeClick(item) {
      // item.isClick = !item.isClick;
      // EaBIM.loadTrueProgress(this.d);
    },
    modelChange(data) {
      this.modelId = data;
      this.selectData = this.options.filter((x) => x.modelId == data)[0];
      this.GetProgressShow();
    },
    viewers(data) {
      data.enterType = "mxzs";
      EaBIM.localServerModels(data);
    },
    //更新模型
    AddOrUpdateProgressShow() {
      this.updateShow = true;
    },
    async GetModelListByXid() {
      let res = await GetModelListByXid({ id: localStorage.xid });
      if (res.Data) {
        res.Data.forEach((v) => v.enterType == "progressShow");
        this.options = res.Data;
        this.modelId = this.options[0].modelId;
        this.selectData = res.Data[0];
        this.GetProgressShow();
      }
    },
    async GetProgressShow() {
      let params = {
        modelId: this.modelId,
      };
      let res = await GetProgressShow({ params });
      this.selectData.list = res.Data ? res.Data : [];
      this.init();
      this.showModel(this.selectData);
    },

    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pgsw07",
          },
          simpleData: {
            enable: true,
            idKey: "pgsw01",
            pIdKey: "pgsw08",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: _this.quanxian ? OnRightClick : false,
          onClick: onclick,
          beforeRename: beforeRename,
          beforeDrop: beforeDrop,
          onCheck: onCheck,
        },
      };
      _this.zTeeObj = $.fn.zTree.init(
        $("#ProgressShowTree"),
        setting,
        _this.selectData.list
      );
      _this.zTeeObj.expandAll(true);
      _this.ids = "";
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.pgsw01;
          _split = ",";
        });
        _this.modelProgress();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.ids = treeNode.pgsw01 + "";
        _this.modelProgress("select");
      }
      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            DropProgressShow({
              oid: moveNode.pgsw01,
              nid: targetNode.pgsw01,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: _this.$t('进度展示.成功'),
            });
            return true;
            break;
        }
        return false;
      }
      function getChildren(ids, treeNode) {
        ids.push(treeNode.pftr01);
        if (treeNode.isParent) {
          for (var obj in treeNode.children) {
            getChildren(ids, treeNode.children[obj]);
          }
        }
        return ids;
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        _this.selectNodes = [];
        if (treeNode) {
          _this.selectNode.pgsw08 = treeNode.pgsw08 + "";
          _this.selectNodes = getChildren(_this.selectNodes, treeNode);
        }
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "ProgressShowRemenu" ||
            $(event.target).parents("#ProgressShowRemenu").length > 0
          )
        ) {
          $("#ProgressShowRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addProgressShow").show();
          $("#updateProgressShow").hide();
          $("#delProgressShow").hide();
        } else {
          $("#addProgressShow").show();
          $("#updateProgressShow").show();
          $("#delProgressShow").show();
        }
        $("#ProgressShowRemenu").show();
        $("#ProgressShowRemenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#ProgressShowRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#ProgressShowRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addProgressShow") {
            var newNode = {},
              params = {};
            params = {
              pgsw01: 0,
              pgsw02: _this.modelId,
              pgsw06: localStorage.id,
              pgsw07: _this.$t('common.新建节点'),
              pgsw08: _this.selectNode == null ? 0 : _this.selectNode.pgsw01,
            };
            AddOrUpdateProgressShow(params).then((res) => {
              if (res.Code > 0) {
                _this.$message({
                  type: "success",
                  message: _this.$t('进度展示.成功'),
                });
                newNode = res.Data;
                _this.zTeeObj.addNodes(_this.selectNode, newNode);
                var currentNode = _this.zTeeObj.getNodeByParam(
                  "pgsw01",
                  newNode.pgsw01
                );
                _this.zTeeObj.selectNode(currentNode);
                _this.zTeeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "waring",
                  message: _this.$t('进度展示.失败'),
                });
              }
            });
          } else if (type == "delProgressShow") {
            _this.$confirm(_this.$t('common.删除询问')).then((_) => {
              var treeNodes = _this.zTeeObj.transformToArray(_this.selectNode);
              var ids = "",
                _split = "";
              treeNodes.forEach((element) => {
                ids += _split + element.pgsw01;
                _split = ",";
              });
              let params = { ids: ids };
              DelProgressShow(params).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: _this.$t('进度展示.成功'),
                  });
                  var currentNode = _this.zTeeObj.getNodeByParam(
                    "pgsw01",
                    _this.selectNode.pgsw01
                  );
                  _this.zTeeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "warning",
                    message: _this.$t('进度展示.失败'),
                  });
                }
              });
            });
          } else {
            // _this.zTeeObj.editName(_this.selectNode);
            _this.AddOrUpdateProgressShow();
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.pgsw07) {
          let params = treeNode;
          params.pgsw07 = newName;
          AddOrUpdateProgressShow(params).then((res) => {
            if (res.Code > 0) {
              _this.$message({
                type: "success",
                message: _this.$t('进度展示.成功'),
              });
            } else {
              _this.$message({
                type: "waring",
                message: _this.$t('进度展示.失败'),
              });
            }
          });
        }
      }
    },
    showModel(data) {
      // data.colors = this.color;
      this.viewers(data);
    },

    // 获取进度状态
    getProgressShowState() {
      let params = {
        xid: localStorage.xid
      };
      getProgressShowState({ params }).then((res) => {
        if (res.Data.length) {
          res.Data.forEach(element => {
            this.color.push({
              name: element.name,
              value: element.color,
              isClick: true
            })
          });
        }
        else
          this.$message.error(this.$t('进度展示.当前项目未设置进度状态'));
      });
    },
  },
  created() {
    this.GetModelListByXid();
    this.getProgressShowState()
    //判断权限
    if (
      (this.$store.state.permissions != null &&
        this.$store.state.permissions.includes("10331")) ||
      this.$store.state.isProject
    ) {
      this.quanxian = true;
    }

    window.DealModelData = this.DealModelData;
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    window.updateViewTime = this.updateViewTime;
    Fcis.Fc(".Yuan", "#drag");

    interact(".Yuan-title").resizable({
      edges: { top: false, left: false, bottom: true, right: true },
      listeners: {
        move: function (event) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });
  },
};
</script>

<style lang="less" scoped>
@import url("../../../../public/Content/css/style.css");

/deep/ .view {
  padding: 0;
}

#MyViewerDiv {
  height: 93%;
  top: 7%;
  width: 100%;
  position: absolute;
  // float: left;
}

.home {
  overflow: auto;
  height: 100%;
  position: relative;
}

div#ProgressShowRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
  z-index: 100;
}

div#ProgressShowRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#ProgressShowRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#ProgressShowRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#ProjectFileTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
</style>
